<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
        
              <div class="header-block">
                <div class="header-title">
                  <!-- <p>Master Data / Asset Group</p> -->
                  <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                  <div class="search">
                    <form autocomplete="off" >
                      <input type="text" placeholder="search" (keyup.enter)="getAllGroupByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
                    </form>
                    <i class="bi bi-search" (click)="getAllGroupByWildSearch()"></i>
                  </div>
  
                  <button *ngIf="actionControls.isAdd" title="Add" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
                  <div class="filter-icon">
                    <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                  </div>
 
                </div>
              </div>
      
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 90%;">{{ 'object-group-master.groupName' | translate }}</th>
                    <th style="width: 10%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>

                  </tr>
                </thead>
              </table>
              <div *ngIf="!isLoading">
                <div class="data-view" id="{{object.id}}" [ngClass]="{ 'delete-highlight': object.objectGroupMasterId == recordId }" *ngFor="let object of objectData | paginate : {
                  itemsPerPage: tableSize,
                  currentPage: page,
                  totalItems: count
                }  ;let i = index">
                  <p style="width: 90%;">{{object.groupName}}</p>
                  <p class="action-buttons" style="width: 10%;">
                    <i class="bi bi-trash3" title="Delete" (click)="deleteIdSelect(object.id,object)" data-toggle="modal" data-target="#deleteModal"></i>
                  </p>
                </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
              </div>
      
              <div class="loader" *ngIf="!isLoading && objectData.length == 0">
                <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
                </div>
              </div>
      
              <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
                  [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
              </div>
            </div>
  
        </div>
    </div>
  </div>
  
  
<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'object-group-master.headings.add' | translate }}
          <span data-dismiss="modal">
            <i data-dismiss="modal" (click)="cancelModel()" class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">

        <div [formGroup]="form">
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <label for="">{{ 'object-group-master.groupName' | translate }} <span class="required">*</span></label>
              <input type="text" id="groupName" (keyup.enter)="addObjectGroup()" (keypress)="blockSpecialChars($event)" class="form-control" formControlName="groupName">
            </div>
          </div>
        </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButton" class="btn btn-secondary" (click)="cancelModel()" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        <button type="button" id="submit" (keydown.enter)="addObjectGroup()" (click)="addObjectGroup()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
      </div>
    </div>
  </div>
  </div>
</div>
  
  



 
<!-- <div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Status Details
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body view">
    
          <div *ngFor="let status of singleStatusMaster">
              <div class="row">
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Name</label>
                          <input type="text" value="{{status.name}}" class="form-control">
                      </div>
                  </div>

                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <label>Status Type</label>
                      <select name="" id="" formControlName="type" class="form-control">
                        <option value="" disabled selected hidden>---select type---</option>
                        <option value="{{status}}" *ngFor="let status of statusTypes">{{status}}</option>
                      </select>
                    </div>
                  </div>
                
                  
                  <div class="col-md-12 col-lg-12">
                      <div class="form-group">
                          <label>Description</label>
                          <textarea class="form-control" value="{{status.description}}" name="" id="" cols="30" rows="10"></textarea>
                      </div>
                  </div>
                
              </div>
          </div>
        <div class="modal-footer">
          <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
    </div>
    </div> -->


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
          <span data-dismiss="modal">
            <i data-dismiss="modal" class="bi bi-x-lg" (click)="clearData()"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>{{ 'generic.deleteText' | translate }}  <span class="delete-span">“{{recordName}}”</span>?</p>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" (click)="clearData()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
          <button type="button" (click)="deleteGroup()" class="btn btn-primary">{{ 'generic.delete' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>